import React from 'react';
import '../App.css';
import { Link } from 'react-router-dom';

const styles = {
    pageWrapper: {
        backgroundColor: '#000',
        width: '100%'
    },

    heroSection: {
        position: 'relative',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        borderBottom: '8px solid rgb(253, 246, 246)'
    },

    video: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transform: 'translate(-50%, -50%)',
        zIndex: 1
    },

    brandOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '40px 20px',
        zIndex: 3
    },

    brandLogo: {
        width: '120px',
        maxHeight: '60px',
        objectFit: 'contain',
        filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5))'
    },

    scrollIndicator: {
        position: 'absolute',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#fff',
        zIndex: 5,
        fontSize: '14px',
        textTransform: 'uppercase',
        letterSpacing: '2px'
    }
};

const Home = () => {
    const brands = [
        {
            id: 1,
            name: 'ROLLS-ROYS',
            logo: '/assets/ROLLS - ROYS SERVICE PARTNER WHITE.png',
            bgImage: '/assets/vertical/RolsRoys_vertical.jpg',
            links: [
                { title: 'Сервис', url: '#' },
                { title: 'Цены', url: '#' },
            ]
        },
        {
            id: 2, name: 'BMW',
            logo: '/assets/bmw_logo.png',
            bgImage: '/assets/vertical/BMW X5 VERTIKAL.jpg',
            links: [
                { title: 'Автомобили в наличии', url: '#' },
                { title: 'Автомобили с пробегом', url: '#' },
                { title: 'Тест - драйв', url: '#' },
                { title: 'BMW Сервис', url: '#' },
            ]
        },
        {
            id: 3, name: 'BMW MOTORRAD',
            logo: '/assets/BMW MOTORRAD LOGO WHITE.png',
            bgImage: '/assets/vertiacal/BMW MOTORRAD VERTIKAL.jpg',
            path: '/motorrad',
            links: [
                { title: 'Модели', url: '/motorrad' },
                { title: 'Тест - драйв', url: '/test-drive' },
                { title: 'MOTORRAD Сервис', url: '/service-request' },
            ]
        },
        {
            id: 4, name: 'NISSAN',
            logo: '/assets/NISSAN LOGO WORD WHITE.png',
            bgImage: '/assets/vertical/NISSAN PATROL VERTIKAL.jpg',
            links: [
                { title: 'Автомобили в наличии', url: '#' },
                { title: 'Тест - драйв', url: '#' },
                { title: 'NISSAN Сервис', url: '#' },
            ]
        },
    ];

    const partners = [
        { name: 'Befit', logo: 'assets/befit.png' },
        { name: 'Nissan', logo: 'assets/nissan_logo.png' },
        { name: 'Rolly Roys', logo: 'assets/rr_logo.png' },
        { name: 'BMW', logo: 'assets/bmw_logo.png' },
    ];


    return (
        <div style={styles.pageWrapper}>
            {/* Первая секция: Видео */}
            <div style={styles.heroSection}>
                <video autoPlay muted loop playsInline style={styles.video}>
                    <source src="/assets/bg_video.mp4" type="video/mp4" />
                </video>
                <div style={styles.scrollIndicator}>Find out more ▾</div>
            </div>

            {/* Вторая секция: Карточки брендов */}
            <div className="brands-section">
                {brands.map((brand) => {
                    // Шаблон внутренного контента для каждой колонки
                    const cardContent = (
                        <div className="brand-card-inner">
                            {/* Заданный фон с затменением (Overlay) */}
                            <div
                                className={`brand-bg brand-bg-${brand.id}`}
                                style={{ backgroundImage: `url($(brand.bgImage))` }}
                            >
                                {/* Контент поверх карточки */}
                                <div style={styles.brandOverlay}>
                                    {/* Логотип сверху */}
                                    <div className="brand-logo-container">
                                        <img src={brand.logo} alt={brand.name} style={styles.brandLogo} />
                                    </div>
                                    {/* Текстовые ссылки снизу */}
                                    <div className="brand-footer">
                                        {brand.links && (
                                            <div className="brand-links-list">
                                                {brand.links.map((link, index) =>(
                                                <span key={index} className="brand-action-link">
                                                    {link.title}
                                                </span>
                                                ))}
                                            </div>
                                        )};
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                    // Если у бренда прописан path (для BMW Motorrad) — вся карточка становится ссылкой Link
                    return brand.path ? (
                        <Link key={brand.id} to={brand.path} className="brand-card clickable-card">
                            {cardContent}
                        </Link>
                    ) : (
                        <div key={brand.id} className="brand-card">
                            {cardContent}
                        </div>
                    );
                })}
            </div>


            {/* Раздел OUR VISION */}
            <section className="vision-section">
                <h2 className="section-title">OUR VISION</h2>
                <p className="vision-text">
                    Transform to an innovative, agile and people-centric organization
                    ready to shape the future of PREMIUM mobility in Uzbekistan.
                </p>
                <div className="stats-container">
                    <div className="stat-item">
                        <span className="stat-value">5000 +</span>
                        <span className="stat-label">Happy clients</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-value">7</span>
                        <span className="stat-label">Total outlets</span>
                    </div>
                </div>
                <button className="pill-button">More about us</button>
            </section>

            {/* Раздел Charity programs */}
            <section className="dark-section">
                <span className="subtitle orange">OUR CHARITY PROGRAMS</span>
                <h2 className="section-title white">DONATED MORE THAN</h2>
                <div className="donation-amount">7 930 536 $</div>
                <button className="pill-button white-btn">Find out more</button>
            </section>

            {/* Раздел OUR PARTNERS */}
            <section className="partners-section">
                <h2 className="section-title">OUR PARTNERS</h2>
                <div className="partners-grid">
                    {partners.map((partner, index) => (
                        <div key={index} className="partner-logo-box">
                            <img src={partner.logo} alt={partner.name} className="partner-logo" />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Home;